import { render, staticRenderFns } from "./middleware.vue?vue&type=template&id=c1fae7a8&scoped=true"
import script from "./middleware.vue?vue&type=script&lang=ts"
export * from "./middleware.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fae7a8",
  null
  
)

export default component.exports